import {Selectors} from '../Settings';
import {$window, $body} from '../../../../../ig_template/Resources/Public/JavaScript/Constants';

/**
 * BannerSlider
 */
export default class BannerSlider {
    constructor($bannerSlider) {
        this.$bannerSlider = $bannerSlider;
        this.init();
    }

    init() {
        this.$bannerSlider.owlCarousel({
            items: 1,
            nav: true,
            navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
            onInitialized: (e) => {
                let $target = this.$bannerSlider.find('.owl-item').eq(e.item.index);
                this.adjustNavPosition($target);

                let timeout;

                $window.on('resize', () => {
                    clearTimeout(timeout);

                    timeout = setTimeout(() => {
                        this.adjustNavPosition($target);
                    }, 500);
                });
            }
        });
    }

    adjustNavPosition($target) {
        /*this.$bannerSlider.find('.owl-nav').css({
            top: $text.position().top + $text.find('.testimonial-logo').height(),
            left: $text.offset().left + $text.width() - 15
        });*/
    }
}